import * as React from "react";
import { SVGProps } from "react";
export function YearsExperienceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.001 19.092a9.09 9.09 0 0 0 9.091-9.09A9.09 9.09 0 0 0 10.002.91 9.09 9.09 0 0 0 .91 10.001a9.09 9.09 0 0 0 9.091 9.091Z"
        stroke="#000"
        strokeWidth={1.636}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.502V10l3.553 4.14"
        stroke="#000"
        strokeWidth={1.636}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
